@if (!loading()) {
  <div
    *hasPermission="[EPermissions.newsReadOwn]"
    data-testid="news-content"
    [class.news-container]="(news()?.length ?? 0) < 3"
    [class.news-container2]="(news()?.length ?? 0) >= 3"
  >
    @for (newsItem of news(); track newsItem.id) {
      <div class="mb-5">
        <span class="text-sm text-shikenso-purple-base-60 text-right block">
          {{ newsItem.start | date: dateFormat() : undefined : locale() }}
        </span>
        <quill-editor
          class="custom-quill-editor"
          [ngModel]="newsItem.message"
          [readOnly]="true"
          [modules]="{ toolbar: false }"
        />
      </div>
    }
  </div>
} @else {
  <div [class.news-container]="estimatedNewsCount() < 3" [class.news-container2]="estimatedNewsCount() >= 3">
    @for (i of createNewsItemArray(); track i) {
      <div class="mb-5">
        <app-skeleton-loader
          containerClass=""
          [columns]="getNewsColumns()"
          [rows]="1"
          [showColumns]="false"
          [showHeaderControls]="false"
          [showPaginator]="false"
        />
      </div>
    }
  </div>
}
